// Constants
export const USER_LOADING = 'USER_LOADING';
export const USER_FULFILLED = 'USER_FULFILLED';
export const USER_LOGOUT = 'USER_LOGOUT';

export const APP_OPTIONS = 'APP_OPTIONS';
export const BANKS = 'BANKS';
